"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
function handleSingleObject(responseData, relation, metaName) {
    if (responseData.relationships) {
        responseData.meta = {
            ...responseData.meta,
            [metaName]: (0, lodash_get_1.default)(responseData, `relationships.${relation}.data.id`, ''),
        };
    }
    return responseData;
}
function getFromRelationship(response, relation, metaName) {
    const responseData = response.data;
    if (Array.isArray(response.data.data)) {
        responseData.data = responseData.data.map((item) => {
            return handleSingleObject(item, relation, metaName);
        });
    }
    else {
        responseData.data = handleSingleObject(responseData.data, relation, metaName);
    }
    return response.data;
}
exports.default = getFromRelationship;
//# sourceMappingURL=getFromRelationship.js.map